module.exports = __webpack_public_path__ + "static/media/umd-logo.d037de48.png";